import React from 'react';
import ReactDOM from 'react-dom';

// polyfill
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import './index.scss';
// import { Provider } from 'react-redux';
// import { store } from './store';

// import { BrowserRouter as Router, Route } from "react-router-dom";

// import PageTop from 'page/top/PageTop'
// import PageIndex from 'page/index/PageIndex'
// import PageActivity from 'page/activity/PageActivity'
// import PageFloor from 'page/floor/PageFloor'
// import PageNew from 'page/new/PageNew'
// import PageFloorMap from 'page/floormap/PageFloorMap'
// import PageAbout from 'page/about/PageAbout'
// import PageAccess from 'page/access/PageAccess'
import AppRoute from './AppRoute'

import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <AppRoute />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
